var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.428 19.983-6.82-3.79-1.742-1.74a3.002 3.002 0 0 0-3.144-.688l-.373-1.494A2.997 2.997 0 0 0 44.44 10H44V7.816a3 3 0 1 0-2 0V10h-.438a2.997 2.997 0 0 0-2.911 2.272l-.373 1.493a3.002 3.002 0 0 0-3.144.687l-1.742 1.742-6.82 3.79A5.002 5.002 0 0 0 24 24.353V29h2v-4.646a3 3 0 0 1 1.543-2.623l6.03-3.35L42 35.236V55h-9v2h7v5h2v-5h2v5h2v-5h7a3.003 3.003 0 0 0 3-3v-2h3a3.003 3.003 0 0 0 3-3V24.354a5.002 5.002 0 0 0-2.572-4.37ZM43 4a1 1 0 1 1-1 1 1.001 1.001 0 0 1 1-1Zm0 28.764-5.967-11.935 1.519 1.266a2.011 2.011 0 0 0 1.282.463 1.825 1.825 0 0 0 .23-.014 2.005 2.005 0 0 0 1.367-.786L43 19.666l1.568 2.092a2.007 2.007 0 0 0 1.367.786 1.825 1.825 0 0 0 .23.014 2.012 2.012 0 0 0 1.284-.463l1.518-1.266Zm6.452-16.898 1.067 1.067-4.35 3.626-1.735-2.313 3.756-2.505a1.004 1.004 0 0 1 1.262.125ZM41.562 12h2.877a.999.999 0 0 1 .97.757l.521 2.087L43 16.798l-2.93-1.954.521-2.086a.999.999 0 0 1 .97-.758Zm-5.014 3.866a1.004 1.004 0 0 1 1.262-.125l3.756 2.505-1.734 2.312-4.35-3.625ZM60 49a1.001 1.001 0 0 1-1 1h-3v-2h4Zm-4-3V27h-2v27a1.001 1.001 0 0 1-1 1h-9V35.236l8.427-16.855 6.03 3.35A3 3 0 0 1 60 24.354V46Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 40,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 45,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 50,
    r: 1,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 62h23a3.003 3.003 0 0 0 3-3v-2a3.003 3.003 0 0 0-3-3H16v-9h4.101A5.015 5.015 0 0 0 24 48.899V52h2v-3.101A5.008 5.008 0 0 0 30 44v-9a3.003 3.003 0 0 0-3-3h-4a3.003 3.003 0 0 0-3 3h-6v-4h-2v4H8v-4H6v4H5a3.003 3.003 0 0 0-3 3v4a3.003 3.003 0 0 0 3 3v9a3.003 3.003 0 0 0-3 3v2a3.003 3.003 0 0 0 3 3Zm18-28h4a1.001 1.001 0 0 1 1 1v9a3 3 0 0 1-6 0v-9a1.001 1.001 0 0 1 1-1ZM4 42v-4a1.001 1.001 0 0 1 1-1h15v6H5a1.001 1.001 0 0 1-1-1Zm3 3h7v9H7ZM4 57a1.001 1.001 0 0 1 1-1h23a1.001 1.001 0 0 1 1 1v2a1.001 1.001 0 0 1-1 1H5a1.001 1.001 0 0 1-1-1Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSer1);
export default __webpack_public_path__ + "static/media/ser-1.6b7169d410688fbf082044f73ba29689.svg";
export { ForwardRef as ReactComponent };